import { useState } from "react";
import { Button, Card, Spinner, Textarea } from "../../shared/ui/index.js";
import { useToast } from "../../shared/toast.js";
import { useEventQr, useUpdateEvent } from "./events.api.js";
import type { EventRow } from "../../shared/types.js";

export function WallPanel({ event }: { event: EventRow }) {
  const qr = useEventQr(event.id);
  const update = useUpdateEvent(event.id);
  const toast = useToast();
  const [msg, setMsg] = useState(event.wallMessage ?? "");
  const [copied, setCopied] = useState(false);

  return (
    <div className="flex flex-col gap-4">
      <Card>
        <h2 className="font-serif text-lg">Écran de projection</h2>
        <p className="mt-1 text-sm text-stone-500">
          Un mur de photos féérique : les contributions des invités défilent en aléatoire, avec un
          QR pour que les nouveaux arrivants ajoutent les leurs. À ouvrir sur l'ordinateur relié
          au vidéoprojecteur.
        </p>

        {qr.data ? (
          <div className="mt-4 flex flex-col gap-3">
            <a
              href={qr.data.showUrl}
              target="_blank"
              rel="noreferrer"
              className="self-start rounded-full bg-stone-900 px-5 py-2.5 text-sm font-medium text-white hover:bg-stone-700"
            >
              Ouvrir l'écran de projection ↗
            </a>
            <div className="flex items-center gap-2">
              <input
                readOnly
                value={qr.data.showUrl}
                onFocus={(e) => e.currentTarget.select()}
                className="min-w-0 flex-1 rounded-lg border border-stone-200 px-3 py-2 text-xs text-stone-500"
              />
              <Button
                variant="ghost"
                className="!px-4 !py-2 !text-xs"
                onClick={() => {
                  navigator.clipboard.writeText(qr.data!.showUrl);
                  setCopied(true);
                  setTimeout(() => setCopied(false), 1500);
                }}
              >
                {copied ? "Copié ✓" : "Copier le lien"}
              </Button>
            </div>
          </div>
        ) : (
          <div className="mt-4">
            <Spinner />
          </div>
        )}
      </Card>

      <Card>
        <h2 className="font-serif text-lg">Message affiché à l'écran</h2>
        <p className="mt-1 text-sm text-stone-500">
          Facultatif — sinon votre histoire est utilisée.
        </p>
        <Textarea
          className="mt-3"
          rows={2}
          maxLength={500}
          value={msg}
          onChange={(e) => setMsg(e.target.value)}
          placeholder="Merci d'être là ce soir — partagez vos plus beaux moments !"
        />
        <Button
          className="mt-3"
          disabled={update.isPending || msg === (event.wallMessage ?? "")}
          onClick={() =>
            update.mutate(
              { wallMessage: msg },
              { onSuccess: () => toast("Message mis à jour") },
            )
          }
        >
          Enregistrer
        </Button>
      </Card>
    </div>
  );
}
